import styled from 'styled-components';
import { CollectionImage } from '~/components/collections';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	height: 250px;
	padding: 20px;
	overflow: hidden;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledUpInfoContainer = styled.div`
	position: relative;
	z-index: 1;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
`;

const StyledName = styled(Text)`
	font-weight: 700;
	font-size: 16px;
	color: #ffffff;
`;

const StyledImage = styled(CollectionImage)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1;
	pointer-events: none;
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	left: 20px;
	right: 20px;
	bottom: 20px;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}

	.currency-icon {
		opacity: 0.5;
	}
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledImage,
	StyledName,
	StyledPriceContainer,
	StyledUpInfoContainer,
};
